var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResturantGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8854_36544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2 3.9V1.5996C17.2 1.26822 16.9314 0.999596 16.6 0.999596H3.4C3.06863 0.999596 2.8 1.26822 2.8 1.5996V3.9M17.2 3.9H2.8M17.2 3.9L18.6861 8.27573C18.8783 8.84165 18.7324 9.46761 18.3098 9.89022L18.1 10.1C17.6029 10.5971 16.7971 10.5971 16.3 10.1V10.1C15.8029 9.60295 14.9971 9.60295 14.5 10.1V10.1C14.0029 10.5971 13.1971 10.5971 12.7 10.1V10.1C12.2029 9.60295 11.3971 9.60295 10.9 10.1V10.1C10.4029 10.5971 9.59706 10.5971 9.1 10.1V10.1C8.60294 9.60295 7.79706 9.60295 7.3 10.1V10.1C6.80294 10.5971 5.99706 10.5971 5.5 10.1V10.1C5.00294 9.60295 4.19706 9.60295 3.7 10.1V10.1C3.20294 10.5971 2.39706 10.5971 1.9 10.1L1.69022 9.89022C1.26761 9.46761 1.1217 8.84165 1.3139 8.27573L2.8 3.9M2.8 13.2V18C2.8 18.5523 3.24769 19 3.79998 19C3.85877 19 3.92466 19 4 19H11.4C11.9523 19 12.4 18.5523 12.4 18V13.2M17.2 13.2V19M10 15.4C8.5 13.9 6.5 13.9 5.2 15.4",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8854_36544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResturantGroupIcon);
export default __webpack_public_path__ + "static/media/resturantGroupIcon.3364264cbec7e35e964dfdf78c73b7ef.svg";
export { ForwardRef as ReactComponent };